import { BaseContextService } from '../../base-context.service';
import { UserRoleResponseDto } from '../dto/response/user-role-response.dto';
import { UserRoleSaveRequestDto } from '../dto/request/user-role-save-request.dto';
import { EnrichedUserRoleResponseDto } from '../dto/response/enriched-user-role-response.dto';
import roleService from '../../role/services/role.service';
import landscapeService from '../../../landscapeAPI/landscape/services/landspace.service';
import buyerService from '../../../buyerAPI/buyer/services/buyer.service';
import { DEFAULT_CONTEXT_ID } from '../../../../utils/UUID';

class UserRoleService extends BaseContextService {
  public async fetchUserRoles(): Promise<UserRoleResponseDto[]> {
    const response = await this.get<UserRoleResponseDto[]>('/userrole');
    return response.data;
  }

  public async fetchUserRoleById(id: string): Promise<UserRoleResponseDto> {
    const response = await this.get<UserRoleResponseDto>(`/userrole/${id}`);
    return response.data;
  }

  public async createUserRole(
    userRole: UserRoleSaveRequestDto
  ): Promise<UserRoleResponseDto> {
    const response = await this.post<UserRoleResponseDto>(
      `/userrole`,
      userRole
    );
    return response.data;
  }

  public async updateUserRole(
    id: string,
    userRole: UserRoleSaveRequestDto
  ): Promise<UserRoleResponseDto> {
    const response = await this.put<UserRoleResponseDto>(
      `/userrole/${id}`,
      userRole
    );
    return response.data;
  }

  public async deleteUserRole(id: string): Promise<void> {
    await this.delete<void>(`/userrole/${id}`);
  }

  public async enrichUserRoles(
    userRoles: UserRoleResponseDto[]
  ): Promise<EnrichedUserRoleResponseDto[]> {
    return Promise.all(userRoles.map((role) => this.enrichUserRole(role)));
  }

  private async enrichUserRole(
    userRole: UserRoleResponseDto
  ): Promise<EnrichedUserRoleResponseDto> {
    const role = await roleService.fetchRoleById(userRole.roleId);
    const contextEntityName = await this.fetchContextEntityName(userRole);
    return {
      ...userRole,
      roleName: role.name,
      contextEntityName: contextEntityName,
    };
  }

  private async fetchContextEntityName(userRole: UserRoleResponseDto) {
    if (userRole.contextId === DEFAULT_CONTEXT_ID) {
      return '';
    }

    const landscape = await landscapeService.fetchLandscapeById(
      userRole.contextId
    );

    if (landscape) {
      return landscape.name;
    } else {
      try {
        const organization = await buyerService.fetchBuyerById(
          userRole.contextId
        );
        if (organization) {
          return organization.name;
        }
      } catch {
        return null;
      }
      return null;
    }
  }
}

const userService = new UserRoleService();
export default userService;
